import { useCallback, useState } from "react";

import { ApiEndpoints, getApiClient, RequestInfoPayload } from "../../../api-http";
import { useDataLayer } from "../../../hooks/use-data-layer";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";
import { SpecialContentHandler } from "../../strips/special-content/types";
import { RequestInfoFormProps } from "./form";

const formTypeToApiEndpoint: Record<RequestInfoFormProps["type"], ApiEndpoints> = {
  [SpecialContentHandler.NewsletterForm]: ApiEndpoints.REQUEST_NEWSLETTER,
  [SpecialContentHandler.RequestDemoForm]: ApiEndpoints.REQUEST_DEMO,
  [SpecialContentHandler.RequestInfoForm]: ApiEndpoints.REQUEST_PRODUCT_INFO,
  [SpecialContentHandler.RequestSupportForm]: ApiEndpoints.REQUEST_SUPPORT,
};

export const usePostInfoForm = (
  type: RequestInfoFormProps["type"]
): {
  postInfoForm: (data: Partial<RequestInfoPayload>) => void;
  isLoading: boolean;
  error: string | null;
} => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { pushEvent } = useDataLayer();
  const postInfoForm = useCallback(
    (data: Partial<RequestInfoPayload>) => {
      setIsLoading(true);
      setError(null);
      getApiClient()
        .post(formTypeToApiEndpoint[type], data, {
          headers: {
            "Accept-Language": "en-GB",
          },
        })
        .then(() => {
          pushEvent({
            event: GoogleAnalyticsEvent.FormSubmit,
            form_topic: type,
          });
        })
        .catch((err) => {
          console.error(err);
          setError(err);
          pushEvent({
            event: GoogleAnalyticsEvent.FormError,
            form_topic: type,
            error: err.toString(),
          });
        })
        .finally(() => {
          setIsLoading(false);
          if (error) console.log(error);
        });
    },
    [error, type, pushEvent]
  );

  return { postInfoForm, isLoading, error };
};
